import { useEffect, useRef } from 'react';

export default function ListElement({ id, comps, setComps, sel, setSel, hov, setHov, dragId, setDragId, dragOverId, setDragOverId, moveElement }) {

    // Only the non-editing rows are draggable, so the rename input stays usable.
    const draggable = sel !== id;
    const isDragOver = dragOverId === id && dragId !== null && dragId !== id;

    const rowRef = useRef(null);

    // When this row becomes the selected element, scroll it into view within
    // the Elements panel only (without scrolling the whole editor).
    useEffect(() => {
        if (sel !== id || !rowRef.current) return;
        const row = rowRef.current;
        let container = row.parentElement;
        while (container && container.scrollHeight <= container.clientHeight) {
            container = container.parentElement;
        }
        if (!container) return;
        const r = row.getBoundingClientRect();
        const c = container.getBoundingClientRect();
        if (r.top < c.top) {
            container.scrollTop -= (c.top - r.top) + 8;
        } else if (r.bottom > c.bottom) {
            container.scrollTop += (r.bottom - c.bottom) + 8;
        }
    }, [sel, id]);

    return (
        <div key={id} ref={rowRef} className='element pointy'
            draggable={draggable}
            onDragStart={() => setDragId && setDragId(id)}
            onDragEnd={() => {
                if (setDragId) setDragId(null);
                if (setDragOverId) setDragOverId(null);
            }}
            onDragOver={(e) => {
                if (dragId === null || dragId === undefined) return;
                e.preventDefault();
                if (dragOverId !== id && setDragOverId) setDragOverId(id);
            }}
            onDrop={(e) => {
                e.preventDefault();
                if (moveElement) moveElement(dragId, id);
                if (setDragId) setDragId(null);
                if (setDragOverId) setDragOverId(null);
            }}
            onMouseOver={() => {
            setHov(id);
        }} onMouseLeave={() => {
            setHov(-1);
        }} style={{
            backgroundColor: hov === id ? 'var(--ed-accent-soft)' : 'var(--ed-surface)',
            color: hov === id ? 'var(--ed-accent)' : 'var(--ed-text)',
            transition: 'background-color 0.1s, color 0.1s',
            marginBottom: 5,
            cursor: draggable ? 'grab' : 'pointer',
            opacity: dragId === id ? 0.4 : 1,
            borderTop: isDragOver ? '2px solid var(--ed-accent)' : undefined
        }} onDoubleClick={() => {
            if (sel === -1) {
                setSel(id);
            }
        }}>
            <i className="fa fa-solid fa-caret-right"></i>
            {sel !== id ?
                <p>{comps[id].name + ' (' + id.toString() + ')'}</p> :
                <>
                    <input style={{
                        marginLeft: '0.5vmax',
                        marginTop: '0.5vmax',
                        marginBottom: '0.5vmax',
                        width: '40%'
                    }} className='panel-input' onChange={(e) => {
                        let new_comps = [...comps];
                        new_comps[id].name = e.target.value;
                        setComps(new_comps);
                    }} value={comps[id].name} />

                    <p>{' (' + id.toString() + ')'}</p>

                    <i className="fa fa-solid fa-angle-up" style={{
                        fontSize: '1vmax',
                        // marginLeft: '20%'
                    }} onClick={() => {
                        let new_comps = [...comps];
                        if (id !== 0) {
                            let above = comps[id - 1];
                            new_comps[id - 1] = new_comps[id];
                            new_comps[id] = above;
                            setComps(new_comps);
                            setSel(id - 1);
                        }
                    }}></i>
                    <i className="fa fa-solid fa-angle-down" style={{
                        fontSize: '1vmax',
                        marginLeft: '0%'
                    }} onClick={() => {
                        let new_comps = [...comps];
                        if (id !== new_comps.length - 1) {
                            let below = comps[id + 1];
                            new_comps[id + 1] = new_comps[id];
                            new_comps[id] = below;
                            setComps(new_comps);
                            setSel(id + 1);
                        }
                    }}>
                    </i>
                </>
            }
        </div>);

}